"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WechatAppletsLoginWithMobile = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var login_1 = require("../../model/login");
var service_1 = require("../../../library/base/service");
var WechatAppletsLoginWithMobile = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(WechatAppletsLoginWithMobile, _super);
    function WechatAppletsLoginWithMobile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '微信登录绑定用户信息--手机号';
        _this.code = '300402';
        _this.desc = '微信登录绑定用户信息--手机号';
        _this.requestParams = new login_1.WechatAppletsLoginWithMobileRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return WechatAppletsLoginWithMobile;
}(service_1.BaseService));
exports.WechatAppletsLoginWithMobile = WechatAppletsLoginWithMobile;
//# sourceMappingURL=wechatAppletsLoginWithMobile.js.map